/**
 * Encodes a string into a URL-safe Base64 format.
 *
 * This function uses standard Base64 encoding and then replaces:
 * '+' with '-', '/' with '_', and removes trailing '=' characters
 * to make the output safe for use in URLs or filenames.
 *
 * @param input - The string to be encoded.
 * @returns A URL-safe Base64 encoded string.
 */

export function safeBase64Encode(input: string): string {
	return btoa(input).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

/**
 * Decodes a URL-safe Base64 string back to its original form.
 *
 * This function reverses the character replacements made by `safeBase64Encode`
 * and pads the string if necessary to meet the Base64 length requirements.
 *
 * @param input - A URL-safe Base64 encoded string.
 * @returns The original decoded string.
 */
export function safeBase64Decode(input: string): string {
	const padded = input.padEnd(input.length + ((4 - (input.length % 4)) % 4), "=");
	return atob(padded.replace(/-/g, "+").replace(/_/g, "/"));
}
